import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { AppBar, Box, Toolbar, useTheme } from "@mui/material";
import { ToolbarRawButton } from "../toolbar/ToolbarRawButton";
import { strings } from "../../localization/LocalizedStrings";
import { ToolbarButton } from "../toolbar/ToolbarButton";
import { PreferencesDialog } from "../PreferencesDialog";
import { IconType } from "../../icons";

export const DrawerHeader: FunctionComponent<IDrawerHeaderProps> = ({ setIsOpen }) => {
  const theme = useTheme();
  const [isPreferencesDialogOpen, setIsPreferencesDialogOpen] = useState(false);
  const piperTextImage = new URL("../../images/piper-text.png", import.meta.url).href;
  return (
    <AppBar position={"sticky"} sx={{ backgroundColor: theme.palette.colors?.appBar }}>
      <Toolbar sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
        <Box className={styles.closeButtonBox}>
          <ToolbarRawButton
            tooltip={strings.close}
            iconType={IconType.MenuOpen}
            onClick={() => setIsOpen(false)}
            buttonClassName={styles.closeButton}
          />
        </Box>
        <img
          className={styles.logoImage}
          style={{
            margin: 8,
            height: 44,
            alignSelf: "center"
          }}
          src={piperTextImage}
          alt={"Piper"}
        />
        <Box flexGrow={1} />
        <ToolbarButton
          className={styles.preferencesButton}
          onClick={() => setIsPreferencesDialogOpen(true)}
          tooltip={strings.settings_preferences_title}
          iconType={IconType.Settings}
        />
      </Toolbar>
      <PreferencesDialog
        isOpen={isPreferencesDialogOpen}
        setIsOpen={setIsPreferencesDialogOpen}
        canRemoveAccount={false}
      />
    </AppBar>
  );
};

export interface IDrawerHeaderProps {
  setIsOpen: (isOpen: boolean) => void;
}
